<template>
    <div class="maintain bg_white">
        <div class="header">
            <button type="create" class="fr" @click="createEvent">新建</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @deleteEvent="deleteEvent"></lists>
        <create ref="create" @updateData="updateData"></create>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import Create from './create'

    export default {
        name: "agent",
        components: {
            Lists, Create
        },
        data() {
            return {
                lists: {
                    title: [{text: '维护人员'}, {text: '点位'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '40%', textAlign: 'left'},
                    {width: '40%', textAlign: 'left'},
                    {width: '20%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/maintain',
                    func: this.httpRequestHandle,
                    error: '获取维护人员信息出错',
                    auto: false
                },
            }
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
            },
            updateData() {
                this.$refs.lists.updateData();
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [
                        {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.user_name},
                        {text: item.point_name},
                        operation
                    ]
                });
            },
            createEvent() {
                this.$refs.create.init();
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除维护人员',
                    tooltipContent: '请输入当前维护人员名称以删除当前维护人员,数据将不可恢复，谨慎操作',
                    value: data.user_name,
                    confirm: () => {
                        this.$api.delete('/manage/maintain/' + data.id).then((res) => {
                            this.$alert.success({content: '删除维护人员成功'});
                            this.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '删除啊维护人员失败'});
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .maintain {
        padding: 0 5px;
    }

    .maintain > .header {
        height: 80px;
        padding: 0 15px;
    }

    .maintain > .header > button {
        margin-top: 20px;
    }
</style>